import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("khgb_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const detail = err?.response?.data?.detail;
    if (detail && typeof detail !== "string") {
      const first = Array.isArray(detail) ? detail[0] : null;
      err.response.data.detail = first?.type === "string_too_long"
        ? "Girilen metin çok uzun"
        : "Girilen bilgiler geçersiz, lütfen alanları kontrol edin";
    }
    if (err?.response?.status === 401) {
      if (localStorage.getItem("khgb_token") && err?.response?.data?.detail) {
        sessionStorage.setItem("khgb_logout_reason", String(err.response.data.detail));
      }
      localStorage.removeItem("khgb_token");
      localStorage.removeItem("khgb_user");
      if (window.location.pathname !== "/giris") {
        window.location.href = "/giris";
      }
    } else if (err?.response?.status === 403 && /şifrenizi değiştirmelisiniz/.test(err?.response?.data?.detail || "")) {
      const u = JSON.parse(localStorage.getItem("khgb_user") || "null");
      if (u) localStorage.setItem("khgb_user", JSON.stringify({ ...u, must_change_password: true }));
      if (window.location.pathname !== "/sifre-degistir") window.location.href = "/sifre-degistir";
    }
    return Promise.reject(err);
  }
);
